import { useState, useEffect } from 'react'

/**
 * Hook to detect mobile viewport
 * Returns true for screens < 768px (mobile/small tablet)
 * Uses window.matchMedia for reliable media query detection
 */
export const useIsMobile = (): boolean => {
  // Initialize with actual current state (not false)
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia('(max-width: 767px)').matches
  })

  useEffect(() => {
    // Media query for mobile detection (< 768px = Tailwind 'md' breakpoint)
    const mediaQuery = window.matchMedia('(max-width: 767px)')

    // Update state if it changed between init and effect
    setIsMobile(mediaQuery.matches)

    // Handler for media query changes
    const handleChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches)
    }

    // Listen for viewport changes
    mediaQuery.addEventListener('change', handleChange)

    // Cleanup
    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [])

  return isMobile
}
